export const getRegistrationDateError = (audience = {}) => {
  const isDateOnlyMode = ["date_time", "date_time_and_template"].includes(audience.registrationMode);
  const isRegStatusMode = audience.registrationMode === "registration_status";
  if (!isDateOnlyMode && !isRegStatusMode) return "";
  const from = audience.registrationDateFrom || audience.registration_date_from;
  const to = audience.registrationDateTo || audience.registration_date_to;
  if (!from && !to) {
    return isDateOnlyMode ? "Select at least one registration date and time" : "";
  }
  const instant = (value) => {
    const raw = String(value);
    return new Date(raw.length === 10 ? `${raw}T00:00:00Z` : /(?:Z|[+-]\d{2}:?\d{2})$/.test(raw) ? raw : `${raw}Z`);
  };
  const valid = (value) => {
    if (!value) return true;
    const raw = String(value);
    const parsed = instant(raw);
    if (Number.isNaN(parsed.getTime())) return false;
    // Round-trip local values to reject impossible calendar dates, without using the browser timezone.
    return /(?:Z|[+-]\d{2}:?\d{2})$/.test(raw) || parsed.toISOString().slice(0, raw.length) === raw;
  };
  if (!valid(from) || !valid(to)) return "Invalid registration date and time";
  if (from && to && instant(from) > instant(to)) return "Registration From date and time must be before or equal to To";
  return "";
};
